import { Button } from '@econsult/econsult-ui/dist/components/Button';
import { TextareaWithCharacterCounter } from '@econsult/econsult-ui/dist/components/Textarea';
import { FlexInputLabel, FlexInputSpan, Form } from 'components/Form';
import { Setting, SettingDetail } from 'components/Setting/style';
import { Divider, ParagraphXSmallRegular } from 'components/Typography';
import styled from 'styled-components';

export const StyledInputLabel = styled(FlexInputLabel)`
  color: ${({ theme }) => theme.colorPrimaryPrimary100};

  ${FlexInputSpan} {
    font-size: 0.875rem;
  }

  &:not(:focus-within) fieldset {
    border-width: 0px;
    border-color: ${({ theme }) => theme.colorNeutralNeutral7} !important;
  }
`;

export const TextAreaWrapper = styled.div`
  border-radius: 0.5rem;
  border: 1px solid ${({ theme }) => theme.colorNeutralNeutral7};

  &:has(.Mui-focused) {
    border-color: ${({ theme }) => theme.colorActionSecondaryDefault};
  }

  ${Divider} {
    margin: 0.5rem 0.5rem 1rem;
  }

  #messageCharCounter {
    padding-top: 0.5rem;
    margin: 0.5rem 0.5rem 0;
    border-top: 1px solid ${({ theme }) => theme.colorNeutralNeutral9};
    color: ${({ theme }) => theme.colorPrimaryPrimary70}
  }
  
  ${ParagraphXSmallRegular} {
    margin: 1rem 1rem 1rem;
  }

  ${SettingDetail} & {
    width: 100%;
    grid-column: 1 / 4;
  }
`;

export const StyledTextArea = styled(TextareaWithCharacterCounter)`
  && .MuiOutlinedInput-root fieldset {
    border-color: transparent !important;
  }

  && .MuiInputBase-input {
    color: ${({ theme }) => theme.colorPrimaryPrimary100};
    font-size: 0.875rem;
  }

  &&:last-child #messageCharCounter {
    margin-bottom: 0.5rem;
  }
`;

export const SubmitMessageButton = styled(Button)`
  &&[type=submit] {
    margin-left: initial;
  }
`;

export const CustomClosureMessageSetting = styled(Setting)`
  & ${Form} {
    align-items: end;
  }
`;
